import DiscountApi from '@apis/discount/DiscountApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';

const discountQueries = createQueryKeys('discounts', {
  list: (shopId: string) => ({
    queryKey: ['list', shopId],
    queryFn: () => DiscountApi.getDiscounts(shopId),
  }),
});

export default discountQueries;
